import useSmsCreditAccess from "@/modules/smsCredit/useSmsCreditAccess";
import { CreateTransactionCreditPayload } from "@/models/payload/wallet";
import walletService from "@/services/wallet";
import { notifications } from "@mantine/notifications";
import { useMutation } from "@tanstack/react-query";

function useIncreaseWallet() {
  const { allowed } = useSmsCreditAccess();
  const {
    mutate: increaseWallet,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: (command: CreateTransactionCreditPayload) => {
      if (!allowed) throw new Error("فقط مدیر مجموعه امکان افزایش شارژ پیامکی دارد");
      return walletService.increaseWalletBalance(command);
    },
    onSuccess: (data) => {
      notifications.show({
        message: "...در حال انتقال به درگاه پرداخت",
        color: "green",
      });
      const platform = localStorage.getItem("platform");
      if (platform === "android") {
        if (window?.ReactNativeWebView) {
          window?.ReactNativeWebView?.postMessage(data?.redirectUrl || "");
        } else {
          console.error("ReactNativeWebView is not available");
        }
      } else {
        window.location.replace(data?.redirectUrl || "");
      }
    },
  });
  return { increaseWallet, isLoading, isSuccess };
}

export default useIncreaseWallet;
